export const DEFAULT_LANGUAGE = 'en';

export const LANGUAGES = {
  en: 'English',
};

export const LANGUAGES_MAPPING = {
  'en-US': 'en',
};
